export enum customUserConfirmationMessages {
  "personalia" = "personalia"
}
